import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const EliminarMensajeDialog = ({
  open,
  mensajeToDelete,
  onClose,
  onConfirmDelete
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 4px 24px rgba(0,0,0,0.1)"
        }
      }}
    >
      <DialogTitle sx={{ 
        color: "#e11d48", 
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        gap: 1.5
      }}>
        <DeleteOutlineIcon color="error" />
        Eliminar mensaje
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1">
          ¿Estás seguro de que deseas eliminar este mensaje?
        </Typography>
        {mensajeToDelete && (
          <Box sx={{ 
            mt: 2, 
            p: 2, 
            background: "#f1f5f9", 
            borderRadius: 2,
            border: "1px solid #e0e7ef" 
          }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#334155" }}>
              {mensajeToDelete.mensaje}
            </Typography>
          </Box>
        )}
        <Typography variant="body2" sx={{ mt: 2, color: "#64748b" }}>
          Esta acción no se puede deshacer.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "#e0e7ef",
            color: "#334155",
            "&:hover": { borderColor: "#6366f1", background: "#f1f5f9" }
          }}
        >
          Cancelar
        </Button>
        <Button 
          onClick={() => onConfirmDelete(mensajeToDelete.id)}
          variant="contained"
          color="error"
          sx={{ fontWeight: 700 }}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EliminarMensajeDialog;